export default "__VITE_ASSET__DTdSLaAN__"